import { i18nMark } from 'lingui-react';

const messages = {
  breadcrumbs: i18nMark('Unit {number}'),
  description: i18nMark('The Asset Detail page of the application'),
  title: i18nMark('The Asset Detail Page'),
};

export default messages;



// WEBPACK FOOTER //
// ./containers/AssetDetailData/messages.js